import { Wirkstoff } from '../../warehouse/material/material';

export class Betriebstyp {
    betriebstyp_id: number;
    betriebstyp: string;
    impfstoff_zusatz: string;
    antibiotika_zusatz: string;
    editiert: Date;
    wirkstoffe: Wirkstoff[] = [];
}
